/** Eigener Status als Zeile (Emoji – auch eigenes/animiertes – plus Text); abgelaufene werden ausgeblendet. */
import type { CustomStatusDto } from '@lagerfeuer/shared';
import type { ReactNode } from 'react';
import { EmojiText } from '../../components/EmojiText';
import { activeCustomStatus } from './customStatus';

export function CustomStatusText({ status, fallback = null, emojiSize = 16 }: { status: CustomStatusDto | null | undefined; fallback?: ReactNode; emojiSize?: number }) {
  const cs = activeCustomStatus(status);
  if (!cs) return <>{fallback}</>;
  return (
    <>
      {cs.emoji && <EmojiText value={cs.emoji} size={emojiSize} className="custom-status-emoji" />}
      {cs.emoji && cs.text && ' '}
      {cs.text}
    </>
  );
}
